import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useRBAC } from '../hooks/useRBAC';
import { useAuth } from '../contexts/AuthContext';
import { PlxsCallout, PlxsText } from '@plexlogic/plexus-ui';

interface SuperUserRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

/**
 * Protected route that only allows Super Users to access
 * Regular users are shown an access denied message
 */
const SuperUserRoute: React.FC<SuperUserRouteProps> = ({ component: Component, ...rest }) => {
  const { isSuperUser, isAuthenticated } = useRBAC();
  const { isLoading } = useAuth();

  if (!isAuthenticated && !isLoading) {
    return <Redirect to="/" />;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isSuperUser ? (
          <Component {...props} />
        ) : (
          <div
            style={{
              maxWidth: '800px',
              margin: '60px auto',
              padding: 'var(--plexus-space-xl, 2rem)',
            }}
          >
            <PlxsCallout 
              tone="urgent"
              message="Access Denied: This feature is only available to Plexus Super Users."
              dataTestId="super-user-access-denied"
            >
              <PlxsText>
                If you believe you should have access, please contact your system administrator.
              </PlxsText>
            </PlxsCallout>
          </div>
        )
      }
    />
  );
};

export default SuperUserRoute;
